import { SaleTypeContainer } from '../../containers/advancedFilters/SaleTypeContainer';
import { IFilter } from '../../types/advancedFilters';

export const saleType: IFilter = {
  component: SaleTypeContainer,
};
